import { useEffect, useState } from "react";
import Seo from "../components/Seo";
import { CTA } from "../components/sections";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { api } from "../lib/api";

export default function Faq() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/content/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);

  const jsonLd = {
    "@context": "https://schema.org", "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.question, acceptedAnswer: { "@type": "Answer", text: f.answer } })),
  };

  return (
    <>
      <Seo title="FAQ | Selling Your Car for Cash | Car To Cash" description="Answers to common questions about selling your car for cash — valuations, finance, write-offs, paperwork, payment and free removal." canonical="https://cartocash.com.au/faq" jsonLd={faqs.length ? jsonLd : null} />
      <section className="noise-dark text-white">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 py-16">
          <h1 className="font-display text-4xl sm:text-5xl font-black">Frequently asked questions</h1>
          <p className="mt-3 text-white/75 text-lg">Everything you need to know about selling your car to Car To Cash.</p>
        </div>
      </section>
      <section className="mx-auto max-w-4xl px-4 sm:px-6 py-16" data-testid="faq-list">
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="rounded-2xl border border-brand-line bg-white px-5" data-testid="faq-item">
              <AccordionTrigger className="text-left font-display font-bold text-brand-navy hover:no-underline">{f.question}</AccordionTrigger>
              <AccordionContent className="text-brand-muted leading-relaxed">{f.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
      <CTA />
    </>
  );
}
